<template>
	<div class="tw--mx-0">
		<title-header class="tw-mb-4">
			<v-layout row wrap justify-end align-center>
				<div class="wrapper-btns">
					<v-btn color="primary btn-action" @click="goToBack">
						<img
							src="/static/img/icons/btn-right-arrow.webp"
							alt="Atrás"
							class="mr-4"
						/>
						Atrás
					</v-btn>
				</div>
			</v-layout>
		</title-header>
		<p-card class="tw-flex tw-p-5 tw-mb-4">
			<div class="tw-flex-1 tw-mx-2">
				<p class="header-interview">FECHA DE ENTREVISTA: <span>{{ evaluationDate }}</span></p>
				<p class="header-interview">CARGO AL QUE APLICA: <span> {{ dataProcessSelected.steps.config[0].details.name }}</span></p>
				<p class="header-interview">ENTREVISTADOR: <span>{{ dataProcessSelected.steps.config[0].details.responsibleEmployeId.fullName }}</span></p>
			</div>
			<div class="tw-flex-1">
				<p class="header-interview">DEPARTAMENTO: <span>{{ dataProcessSelected.job.areas.name || '' }}</span></p>
				<p class="header-interview">ESTADO CIVIL: <span>{{ statusCivil }}</span></p>
				<p class="header-interview">NOMBRE DEL CANDIDATO: <span>{{ applicantSelected.applicant.name }} {{ applicantSelected.applicant.lastName }}</span></p>
			</div>
			<div class="tw-flex-1 tw-mx-2">
				<p class="header-interview">NÚMERO: <span>{{ applicantSelected.applicant.phoneNumber }}</span></p>
				<p class="header-interview">EDAD: <span>{{ applicantSelected.applicant.age }}</span></p>
			</div>
		</p-card>
		<div class="tw-flex tw--mx-0">
			<div class="tw-pr-3 tw-w-3/5">
				<section class="interview-list" v-if="dataInterviewLoad">
					<div class="tw-flex tw-flex-col" v-for="(subfactorI, indexI) in dataInterviewLoad.subFactors" :key="indexI">
						<p-card class="tw-flex tw-flex-col tw-p-none tw-justify-between tw-mb-3">
							<div class="tw-p-3">
								<span class="text-lg"
									><b>{{ subfactorI.description }}</b>
								</span>
							</div>
							<p-horizontal-divider mx="0" my="0" />
							<ul class="custom-list" v-for="(question, indexQ) in subfactorI.questions" :key="indexQ">
								<li>{{ question.description }}</li>
							</ul>
							<v-radio-group v-model="subfactorI.score" class="radio-list">
								<div class="tw-flex tw-px-3 tw-justify-between  tw-gap-x-2">
									<div v-for="(equivalence, indexEq) in subfactorI.equivalences" :key="indexEq">
										<v-radio
											:label="equivalence.description"
											:value="equivalence.value"
											direction="horizontal"
											color="success"
											style="background: white;"
											class="custom-checkbox"
											@change="selectEquivalence(equivalence.value, indexI)"
										>
										</v-radio>
									</div>
								</div>
							</v-radio-group>
							<div class="ckeditor-container">
								<ckeditor :editor="editor" v-model="subfactorI.comentary" :config="editorConfig"/>
							</div>
						</p-card>
					</div>
				</section>
				<div class="tw-flex tw-justify-center tw-items-center tw-my-4">
					<p-button
						type="primary"
						:disabled="validateCommentaries || validateScore"
						@click="saveInterview">Guardar</p-button>
				</div>
			</div>
			<div class="tw-pl-3 tw-w-2/5 sticky-container" id="sticky-container">
				<model-description
					:title="'PROCESO DE SELECCIÓN'">
					<div class="tw-mt-0 tw-mb-11 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
						<div class="">
							El puntaje de esta entrevista es: <span style="font-weight: bold;">{{ applicantSelected.recruitment.steps.config[1].details[0].score }} puntos</span>
						</div>
						<div class="tw-w-full tw-my-4">
							<table class="table-eqivalences">
								<tr>
									<th></th>
									<th :style="`color:${$appColors.secondary};`">NA</th>
									<th :style="`color:${$appColors.secondary};`">Bx</th>
									<th :style="`color:${$appColors.secondary};`">Sx</th>
									<th :style="`color:${$appColors.secondary};`">Ex</th>
									<th :style="`color:${$appColors.secondary};`">Total</th>
								</tr>
								<tr v-for="(subfactor, indexSF) in dataInterviewLoad.subFactors">
									<td :style="`padding: 5px; color:; text-align: left; padding-left: 10px;`">{{ subfactor.description }}</td>
									<td style="width: 40px;" v-for="(equivalence, indexE) in subfactor.equivalences" :key="indexE">
										{{ equivalence.value }}
									</td>
									<td style="width: 40px;">
										{{ subfactor.score || '-' }}
									</td>
								</tr>
								<tr>
									<td :style="`padding: 5px 0 5px 10px; color:${$appColors.primary}; text-align: left;`" colspan="5">TOTALES</td>
									<td :style="`color:${$appColors.primary}; padding: 5px;`">{{ calcTotalScore }}</td>
								</tr>
								<tr>
									<td :style="`padding: 5px 0 5px 10px; color:${$appColors.primary}; text-align: left;`" colspan="5">TOTAL SOBRE EL PUNTAJE DE LA ENTREVISTA</td>
									<td :style="`color:${$appColors.primary}; padding: 5px;`">{{ totalScoreForFactor }}</td>
								</tr>
							</table>
						</div>
						<div class="tw-mb-12 tw-text-left">
							<h3 :style="`color:${$appColors.secondary};`">Equivalencias</h3>
							NA = No Aceptable<br>
							Bx = Bajo al Promedio<br>
							Sx = Superior al Promedio<br>
							Ex = Excelente
						</div>
					</div>
				</model-description>
			</div>
		</div>
	</div>
</template>

<script>
import titleHeader from '@/components/diagnosis/title-header';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr, clone } from 'ramda';

const { getLocalData, roundTo } = helper;

window.addEventListener('scroll', () => {
	const element = document.getElementById('sticky-container');
	const sticky = 85;
	if (window.pageYOffset > sticky) {
		element.classList.add('sticky');
	} else {
		element.classList.remove('sticky');
	}
});

export default {
	name: 'interview',
	components: {
		titleHeader,
		PCard,
		PButton,
		PHorizontalDivider,
		modelDescription,
	},
	mounted() {
		this.dataInterviewLoad = clone(this.dataInterview);
	},
	data() {
		return {
			evaluationDate: null,
			editor: ClassicEditor,
			editorData: '',
			editorConfig: {
				toolbar: {
					shouldNotGroupWhenFull: true,
					items: ['undo', 'redo', 'heading', 'bold', 'italic', 'bulletedList', 'numberedList'],
				},
				image: {
					uploadEnabled: false,
					toolbar: ['imageTextAlternative'],
				},
				table: {
					contentToolbar: [],
				},
			},
			selectedEquivalence: [],
			dataInterviewLoad: {},
			totalScoreSubFactor: 0,
		};
	},
	created() {
		this.evaluationDate = this.$today;
	},
	methods: {
		goToBack() {
			this.goTo('list-applicants');
		},
		selectEquivalence(checkSelected, indexSubF) {
			this.dataInterviewLoad.subFactors[indexSubF].score = Number(checkSelected);
		},
		async saveInterview() {
			const stepProcess = this.applicantSelected.recruitment.steps.config[0].details;
			const body = {
				interview: {
					interviewer: {
						id: stepProcess.responsibleEmployeId.id,
						name: stepProcess.responsibleEmployeId.fullName,
					},
					name: this.applicantSelected.recruitment.steps.config[1].details[0].name,
					score: this.applicantSelected.recruitment.steps.config[1].details[0].score,
					subFactors: this.dataInterviewLoad.subFactors,
					totalScore: this.totalScoreForFactor,
				},
				flag: false,
			};
			try {
				await this.$httpPraktiko.patch(`applicants-recruitment/factors-interview/${this.applicantSelected.recruitmentId}/${this.applicantSelected.applicantId}`, body);
				this.showNotification('Encuesta Guardada Correctamente');
				this.goTo('list-applicants');
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		...mapState('recruitment', {
			dataProcessSelected(state) {
				return pathOr(getLocalData('dataProcessSelected'), ['recruitmentFlow', 'dataProcessSelected'], state.recruitment) || [];
			},
			dataInterview(state) {
				return pathOr(getLocalData('dataInterview'), ['recruitmentFlow', 'dataInterview'], state.recruitment) || [];
			},
			applicantSelected(state) {
				return pathOr(getLocalData('applicantSelected'), ['recruitmentFlow', 'applicantSelected'], state.recruitment) || [];
			},
			validateCommentaries() {
				const noCommentary = Object.keys(this.dataInterviewLoad).length > 0 ?
					this.dataInterviewLoad.subFactors
						.some(dt => !dt.comentary || dt.comentary === null || dt.comentary.trim() === '') : false;
				return noCommentary;
			},
			validateScore() {
				const noScore = Object.keys(this.dataInterviewLoad).length > 0 ?
					this.dataInterviewLoad.subFactors
						.some(dt => dt.score === null) : false;
				return noScore;
			},
			calcTotalScore() {
				this.totalScoreSubFactor = Object.keys(this.dataInterviewLoad).length > 0 ?
					this.dataInterviewLoad.subFactors
						.reduce((accumulator, currentValue) => accumulator + currentValue.score, 0) : 0;
				return this.totalScoreSubFactor;
			},
			totalScoreForFactor() {
				const score = this.applicantSelected.recruitment.steps.config[1].details[0].score;
				const result = (this.totalScoreSubFactor * score) / 100;
				return roundTo(result, 2);
			},
		}),
		statusCivil() {
			if (this.applicantSelected.applicant.civilStatusId === 264) {
				return 'Soltero/a';
			} else if (this.applicantSelected.applicant.civilStatusId === 265) {
				return 'Casado/a';
			} else if (this.applicantSelected.applicant.civilStatusId === 266) {
				return 'Divorciado/a';
			} else if (this.applicantSelected.applicant.civilStatusId === 267) {
				return 'Viudo/a';
			} else if (this.applicantSelected.applicant.civilStatusId === 268) {
				return 'Unión Libre';
			}
			return '';
		},
	},
};
</script>

<style lang="scss" scoped>
.header-interview {
	color: color(gray-sidebar) !important;
	font-size: size(large);
	font-weight: bold;

	span {
		color: color(placeholder);
	}
}
.table-eqivalences {
	width: 100%;
	td {
		border-bottom: 1px solid color(placeholder);
	}
}
.interview-list {
	max-height: 90vh !important;
	overflow: auto;

	span {
		color: map-get($colors, gray-sidebar);
		font-size: 16px !important;
	}
}
.custom-list {
  list-style: none;
  border-bottom: 1px solid color(border-gray);
  padding: 5px 20px;
}

.custom-list li {
  margin-bottom: 5px;
  color: color(gray-sidebar);
}
.ckeditor-container {
	border-radius: 9px;
	max-height: 15vh;
	overflow: auto;
	color: color(gray-sidebar);
	border: 1px solid color(border-gray);
}
.radio-list {
    display: flex;
	justify-content: center;
	align-content: center;
	height: auto;
	width: 100%;
}
.sticky-container {
    position: relative;
    z-index: 1;
	transition: top 0.3s ease;
}

.sticky {
    position: fixed;
	right: 104px;
    top: 85px; 
    width: 30.5%;
    z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/interview.vue